import React, { createContext, useContext } from 'react';
const ToastContext = createContext(undefined);
export const ToastProvider = ({ onClose, status, children }) => (React.createElement(ToastContext.Provider, { value: {
        status,
        onClose,
    } }, children));
export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
//# sourceMappingURL=ToastContext.js.map